module.exports = __webpack_public_path__ + "static/media/screenshot(2).f234c490.jpg";